import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';

function VehicleTypeSelector({ isOpen, onClose, onApply }) {
    const [selectedTypes, setSelectedTypes] = useState([]);
  
    const vehicleTypes = [
      { id: 'cars', label: 'Cars' },
      { id: 'trucks', label: 'Trucks' },
      { id: 'buses', label: 'Buses' },
      { id: 'motorcycles', label: 'Motorcycles' },
      { id: 'bicycles', label: 'Bicycles' }
    ];
  
    const handleTypeToggle = (typeId) => {
      setSelectedTypes(prev => {
        if (prev.includes(typeId)) {
          return prev.filter(id => id !== typeId);
        } else {
          return [...prev, typeId];
        }
      });
    };
  
    if (!isOpen) return null;
  
    return (
      <div className="vehicle-type-overlay">
        <div className="vehicle-type-modal">
          <div className="vehicle-type-header">
            <h3>Select Vehicle Type</h3>
            <button className="close-button" onClick={onClose}>
              <FaTimes />
            </button>
          </div>
          
          <div className="vehicle-type-grid">
            {vehicleTypes.map(type => (
              <label key={type.id} className="vehicle-type-option">
                <input
                  type="checkbox"
                  checked={selectedTypes.includes(type.id)}
                  onChange={() => handleTypeToggle(type.id)}
                />
                <span>{type.label}</span>
              </label>
            ))}
          </div>
  
          <div className="vehicle-type-footer">
            <button className="cancel-link" onClick={onClose}>Cancel</button>
            <button 
              className="apply-button" 
              onClick={() => {
                onApply(selectedTypes);
                onClose();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    );
  }

export default VehicleTypeSelector; 